import { Moment } from 'moment';
import apiClient from '../../../Services/ApiClient';
import { CalendarPrintType } from '../Enums/CalendarPrintType.enum';

export const calendarPrint = async ({
	type,
	dateFrom,
	dateTo,
	workplaceId,
}: {
	type: CalendarPrintType;
	dateFrom: Moment;
	dateTo: Moment;
	workplaceId: string;
}) => {
	const printWindow = window.open('', '_blank');

	try {
		const response = await apiClient.get(
			`workplaces/${workplaceId}/print/${type}?dateFrom=${dateFrom?.format(
				'YYYY-MM-DD',
			)}&dateTo=${dateTo?.add(-1, 'minutes')?.format('YYYY-MM-DD')}`,
		);

		if (response.status === 200 && response.data && printWindow) {
			const document = printWindow.document;
			document.open();
			document.write(response.data);
			document.close();
		} else {
			printWindow?.close();
		}
	} catch (e) {
		printWindow?.close();
		throw e;
	}
};
